var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "confirm",
        {
          staticClass: "big no-padding-confirm",
          attrs: {
            closeIcon: true,
            showMask: true,
            title: _vm.$t("walletQuota.list.title"),
            close: _vm.close
          }
        },
        [
          _c(
            "wallet-table",
            {
              staticClass: "mining-small-staking-list-table",
              attrs: {
                clickCell: _vm.clickCell,
                headList: _vm.heads,
                contentList: _vm.contentList
              }
            },
            [
              _vm._l(_vm.contentList, function(item, i) {
                return _c(
                  "span",
                  {
                    key: i,
                    class: {
                      cancel: true,
                      active: item.canCancel
                    },
                    attrs: { slot: i + "cancelBefore" },
                    slot: i + "cancelBefore"
                  },
                  [_vm._v(_vm._s(_vm.$t("walletQuota.withdrawalStaking")))]
                )
              }),
              _vm._v(" "),
              _c("pagination", {
                staticClass: "__tb_pagination",
                attrs: {
                  slot: "tableBottom",
                  totalPage: _vm.totalPage,
                  currentPage: _vm.pageIndex + 1,
                  toPage: _vm.getStakingList
                },
                slot: "tableBottom"
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }